import { REQUEST_TYPE_ACCESS, REQUEST_TYPE_GUARDING } from './value';

/**
 * The step an amendment opens on, so the amender walks the same chain a new
 * request does instead of being dropped into the middle of it.
 *
 * Step NUMBERS are route segments, not positions: retail sites reorder the
 * access and guarding chains without renumbering the routes.
 *
 *   access, standard: 1 Job Details -> 2 Date -> 3 Visitors -> 4 Access Type -> 5 Review
 *   access, retail:   2 Date -> 3 Visitors -> 1 Job Details -> 5 Review
 *   guarding, standard: 1 Job Details -> 2 Date -> 3 Visitors -> 4 Review
 *   guarding, retail:   2 Date -> 3 Visitors -> 1 Job Details -> 4 Review
 *
 * So on a retail site, route step 1 (Job Details) is the THIRD screen of the
 * chain — which is why amending a retail general visit appeared to "jump to
 * step 3". Retail starts at route step 2 instead.
 *
 * Visitor requests have no retail variant and start at step 2 (site selection
 * is already done), which is unchanged.
 */
export const amendmentStartStep = (type: string | null | undefined, isRetail: boolean): number => {
    if (type === REQUEST_TYPE_ACCESS || type === REQUEST_TYPE_GUARDING) {
        return isRetail ? 2 : 1;
    }

    return 2;
};

export default amendmentStartStep;
